import React from "react";

const DayOfWeek = ({ day }) => {
  return <div className="dayName col">{day}</div>;
};

export default DayOfWeek;
